import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Mail, Save, Loader2, ChevronDown } from "lucide-react";

const inp = "w-full rounded-xl border-2 border-[#E5DECF] bg-white px-3 py-2 font-body text-sm text-[#1F2937] outline-none focus:border-[#0D9488]";

export const SmtpCard = () => {
  const [open, setOpen] = useState(false);
  const [configured, setConfigured] = useState(false);
  const [saving, setSaving] = useState(false);
  const [f, setF] = useState({ host: "", port: 587, username: "", password: "", from_email: "", from_name: "ZoodLeap", use_tls: true, use_ssl: false });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  useEffect(() => {
    api.getSmtp().then((d) => {
      setConfigured(d.configured);
      if (d.smtp) setF((p) => ({ ...p, ...d.smtp, password: "" }));
    }).catch(() => {});
  }, []);

  const save = async () => {
    if (!f.host || !f.from_email) { toast.error("Host and from-email are required"); return; }
    setSaving(true);
    try { await api.setSmtp({ ...f, port: Number(f.port) || 587 }); toast.success("Email settings saved — invites will send from your server"); setConfigured(true); }
    catch (e) { toast.error(formatApiError(e)); } finally { setSaving(false); }
  };

  return (
    <div className="rounded-3xl border border-[#E5DECF] bg-white p-5" data-testid="smtp-card">
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between" data-testid="smtp-toggle">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#7A3FF2]/10 text-[#7A3FF2]"><Mail size={18} /></div>
          <div className="text-left">
            <h3 className="font-heading font-bold text-[#1F2937]">Email delivery (SMTP)</h3>
            <p className="font-body text-xs text-[#6B7280]">{configured ? "Configured — invites email from your server" : "Optional — add your mail server to email invites (otherwise share links)"}</p>
          </div>
        </div>
        <ChevronDown size={18} className={`text-[#94A3B8] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <label className="text-xs font-bold">SMTP host<input value={f.host} onChange={(e) => set("host", e.target.value)} data-testid="smtp-host" className={inp} placeholder="smtp.yourdomain.com" /></label>
          <label className="text-xs font-bold">Port<input type="number" value={f.port} onChange={(e) => set("port", e.target.value)} data-testid="smtp-port" className={inp} /></label>
          <label className="text-xs font-bold">Username<input value={f.username} onChange={(e) => set("username", e.target.value)} data-testid="smtp-username" className={inp} placeholder="apikey / user" /></label>
          <label className="text-xs font-bold">Password<input type="password" value={f.password} onChange={(e) => set("password", e.target.value)} data-testid="smtp-password" className={inp} placeholder={configured ? "•••• (unchanged)" : ""} /></label>
          <label className="text-xs font-bold">From email<input value={f.from_email} onChange={(e) => set("from_email", e.target.value)} data-testid="smtp-from-email" className={inp} placeholder="invites@yourdomain.com" /></label>
          <label className="text-xs font-bold">From name<input value={f.from_name} onChange={(e) => set("from_name", e.target.value)} data-testid="smtp-from-name" className={inp} /></label>
          <label className="flex items-center gap-2 text-xs font-bold"><input type="checkbox" checked={f.use_tls} onChange={(e) => set("use_tls", e.target.checked)} data-testid="smtp-tls" /> Use STARTTLS</label>
          <label className="flex items-center gap-2 text-xs font-bold"><input type="checkbox" checked={f.use_ssl} onChange={(e) => set("use_ssl", e.target.checked)} data-testid="smtp-ssl" /> Use SSL (port 465)</label>
          <button onClick={save} disabled={saving} data-testid="smtp-save" className="col-span-full inline-flex items-center justify-center gap-2 rounded-full bg-[#7A3FF2] px-5 py-2.5 font-heading font-bold text-white hover:brightness-95 disabled:opacity-50">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Save email settings
          </button>
        </div>
      )}
    </div>
  );
};
